import {serverHost} from "../../../../../../http_common.js";
import { useEffect, useReducer, useState, useRef } from "react";
import "./inventoryWorkFlows.css";
import axios from "axios";
import { useSnackbar } from "notistack";
import * as Action from "../../../../../../store/redux/terminal_reducer.js";
import { useDispatch, useSelector } from "react-redux";
// Sounds
import SuccessSound from "../../sounds/sold.wav";
import ErrorSound from "../../sounds/error.wav";
//
import Imgs from "../../images/Udupss_girl.png";
import OnholdTransactions from "../OnholdTransactions";
import ForumRoundedIcon from "@mui/icons-material/ForumRounded";
import EventRoundedIcon from "@mui/icons-material/EventRounded";
import WorkspacePremiumRoundedIcon from "@mui/icons-material/WorkspacePremiumRounded";
import AccountCircleRoundedIcon from "@mui/icons-material/AccountCircleRounded";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import AddShoppingCartOutlinedIcon from "@mui/icons-material/AddShoppingCartOutlined";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import CallIcon from "@mui/icons-material/Call";
import AddOutlinedIcon from "@mui/icons-material/AddOutlined";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";
import { isDraft } from "@reduxjs/toolkit";
import IsLoading from "../../../../../../IsLoading.jsx";

let contacts;

export function OnHold({ salesPayload, handleOnHold,   id, onCancel  }) {
  const [note, setNote] = useReducer((state, payload) => {
    return ({ ...state, ...payload }, { note: "" });
  });
    const {
    cart,
    discount,
    customerName,
    setLoading,
    secondaryFunction,
    setAlert,
    subTotal,
    tax,
    total
  } = salesPayload;

  return (
    <div
      className="putOnHoldCont fx-cl space2"
      onClick={(e) => e.stopPropagation()}
    >
      <div className="putOnHoldhead fx-ac spacem fx-jc">
        <p>Hold Transaction</p>
      </div>
      <div className="putOnHoldDisc fx-cl">
        <div className="putOnHoldRow ">
          <div className="fx-ac spacem">
            <ShoppingCartIcon fontSize="large" /> <span>Products:</span>
          </div>
          <p>{cart?.length} items</p>
        </div>
        <div className="putOnHoldRow ">
          <div className="fx-ac spacem">
            <EventRoundedIcon fontSize="large" /> <span>Grand Total:</span>
          </div>
          <p>
            <strong>
              ₦{" "}
              {total.toLocaleString()}
            </strong>
          </p>
        </div>
        <div className="putOnHoldRow">
          <div className="fx-ac spacem">
            <WorkspacePremiumRoundedIcon fontSize="large" />{" "}
            <span>Discount:</span>
          </div>
          <p>None</p>
        </div>
        <div className="putOnHoldRow ">
          <div className="fx-ac spacem">
            <AccountCircleRoundedIcon fontSize="large" /> <span>Customer:</span>
          </div>
          <p>{customerName}</p>
        </div>
      </div>
      <div className="putOnHoldButtom fx-cl space2 fx-jc">
        <div className="fx-ac">
          <textarea
            name=""
            id=""
            cols="3"
            placeholder="This support grant is desgined eligible applicants."
            onChange={(x) => setNote({ note: x.target.value })}
          ></textarea>
        </div>

        <div className="fx-ac space3 fx-js">
          <button 
          style={{backgroundColor: "#f85a38", color: "#fff"}}
            onClick={onCancel}
          >
           Cancel
          </button> 
          <button
            onClick={() => {
              handleOnHold(note?.note, id);
            }}
          >
            Put On-hold
          </button>
        </div>
      </div>
    </div>
  );
}
export function AddNewProduct({ handleOnHold }) {
  return (
    <div
      className="OpBtnCont fx-cl space2"
      onClick={(e) => e.stopPropagation()}
    >
      <h3>Are you sure you want to prospond this selling?</h3>
      <p>You are about to temporarily save this transaction</p>
      <div className="fx-ac space3 fx-jb">
        <button>Cancel</button>
        <button
          onClick={() => {
            handleOnHold();
          }}
        >
          Prospond
        </button>
      </div>
    </div>
  );
}
export function ClearCart({ clearCart, cart, customer, setOpenModal }) {
  const [cashCollected, setCashCollected] = useState(0);
  const grandTotal = cart?.reduce(
    (sum, item) => sum + item.pricing.sellingPrice * item.soldQuantity,
    0,
  );
  return (
    <div
      className="workflowDisplayCont clearCartCont fx-cl space2"
      onClick={(e) => e.stopPropagation()}
    >
      <div className="fx-cl space2">
        <div className="clearCarthead fx-ac fx-jc">
          <figure>&nbsp;</figure>
          <p>Are you sure?</p>
          <figure>&nbsp;</figure>
        </div>
        <div className="clearCartDiscCont ">
          <div className="clearCartDisc fx-cl">
            <div className="clearCartRow">
              <div className="fx-ac spacem">
                <WorkspacePremiumRoundedIcon fontSize="large" />{" "}
                <span>Customer:</span>
              </div>
              <p> {customer.toLocaleString()}</p>
            </div>
            <div className="clearCartRow ">
              <div className="fx-ac spacem">
                <ShoppingCartIcon fontSize="large" /> <span>Products:</span>
              </div>
              <p>{cart?.length} items</p>
            </div>
            <div className="clearCartRow ">
              <div className="fx-ac spacem">
                <EventRoundedIcon fontSize="large" /> <span>Grand Total:</span>
              </div>
              <p>
                <strong>₦ {grandTotal.toLocaleString()}</strong>
              </p>
            </div>
          </div>
        </div>
        <div className="clearCartButtom fx-cl space2 fx-ac">
          <p>
            Are you sure you want to delete this transaction? All associated
            records for this transaction will be permanently removed.
          </p>

          <div className="fx-ac space3 fx-jc">
            <button
              onClick={() => {
                setOpenModal(false);
              }}
            >
              Cancel
            </button>
            <button
              onClick={() => {
                clearCart();
              }}
            >
              Clear all
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
export function SaveDraft({salesPayload}){
 const {cart,discount,customerName,setLoading,secondaryFunction,setAlert,subTotal,tax,total}=salesPayload;const {enqueueSnackbar}=useSnackbar();const register=useSelector(state=>state.terminalActions?.registerData),company=salesPayload.companyData;
 const recordId=useRef(`DRAFT-${window.crypto.randomUUID()}`),pending=useRef(false);
 async function saveDraft(){if(pending.current)return;if(!company?.clientId||!register?.inventory?.inventoryId){setAlert({type:'error',message:'Open a company inventory register before saving.'});return;}pending.current=true;setLoading(true);try{const response=await axios.post(`${serverHost}/client/${encodeURIComponent(company.clientId)}/point_of_sales/save_draft`,{clientId:company.clientId,draftId:recordId.current,inventoryId:register.inventory.inventoryId,items:cart,customerId:salesPayload.customerId==='EDK323K3J2'?'':salesPayload.customerId,customer_name:customerName,totals:{discount:typeof discount==='object'?discount:0,taxAmount:tax||0}});if(![200,201].includes(response.data.status))throw new Error(response.data.message);setAlert({type:'success',message:response.data.message});enqueueSnackbar(response.data.message,{variant:'success'});secondaryFunction?.();}catch(error){setAlert({type:'error',message:error.response?.data?.message||error.message});}finally{pending.current=false;setLoading(false);}}
 return (
   <div
  className="saveDraftCard  fx-cl space2"
  onClick={(e) => e.stopPropagation()}
>
  <main>
    <div className="fx-cl space2">
      <h3 className="fs6 fw300">Save This Transaction as a Draft?</h3>

      <div className="fx-cl spacem">
        <p>
          This transaction will be saved as a draft, allowing you to continue,
          review, and complete it later without finalizing the sale.
        </p>

        <p>
          Saving as a draft will not update inventory, process any payment, or
          generate a completed sales receipt until the transaction is finalized.
        </p>
      </div>
    </div>

    <div
      className="cashPaymentDisc fx-cl"
      style={{
        padding: "0 3rem",
        width: "37rem",
      }}
    >
      <div className="cashPaymentRow">
        <div className="fx-ac spacem">
          <ShoppingCartIcon fontSize="large" />
          <span>Products:</span>
        </div>
        <p>{cart?.length} items</p>
      </div>

      <div className="cashPaymentRow">
        <div className="fx-ac spacem">
          <EventRoundedIcon fontSize="large" />
          <span>Grand Total:</span>
        </div>
        <p>
          <strong>₦ {total.toLocaleString()}</strong>
        </p>
      </div>

      <div className="cashPaymentRow">
        <div className="fx-ac spacem">
          <WorkspacePremiumRoundedIcon fontSize="large" />
          <span>Discount:</span>
        </div>
        <p>₦ {discount?.amount || 0.0}</p>
      </div>

      <div className="cashPaymentRow">
        <div className="fx-ac spacem">
          <AccountCircleRoundedIcon fontSize="large" />
          <span>Customer:</span>
        </div>
        <p style={{ color: "#fff", fontWeight: "bold" }}>
          {customerName}
        </p>
      </div>
    </div>
  </main>

  <div className="fx-ac fx-jb space3">
    <input
      type="text"
      className="saveDraftDiscription"
      placeholder="Draft description..."
    />

    <button className="animatedBtnShine" onClick={() => saveDraft()}>
      Save Draft
    </button>
  </div>
</div>
  );
 }
export function Quotation({salesPayload}){
 const {cart,discount,customerName,setLoading,secondaryFunction,setAlert,subTotal,tax,total}=salesPayload;const {enqueueSnackbar}=useSnackbar();const register=useSelector(state=>state.terminalActions?.registerData),company=salesPayload.companyData;
 const recordId=useRef(`QUOTATION-${window.crypto.randomUUID()}`),pending=useRef(false);
 async function saveQuotation(){if(pending.current)return;if(!company?.clientId||!register?.inventory?.inventoryId){setAlert({type:'error',message:'Open a company inventory register before saving.'});return;}pending.current=true;setLoading(true);try{const response=await axios.post(`${serverHost}/client/${encodeURIComponent(company.clientId)}/point_of_sales/quotation`,{clientId:company.clientId,quoteId:recordId.current,inventoryId:register.inventory.inventoryId,quoteItems:cart,customerId:salesPayload.customerId==='EDK323K3J2'?'':salesPayload.customerId,customer_name:customerName,totals:{discount:typeof discount==='object'?discount:0,taxAmount:tax||0}});if(![200,201].includes(response.data.status))throw new Error(response.data.message);setAlert({type:'success',message:response.data.message});enqueueSnackbar(response.data.message,{variant:'success'});secondaryFunction?.();}catch(error){setAlert({type:'error',message:error.response?.data?.message||error.message});}finally{pending.current=false;setLoading(false);}}
 return ( 
        <div className="saveQuotsCard fx-cl space2"onClick={(e) => e.stopPropagation()}>
          <main>
            <div className="fx-cl space2">
    <h3 className="fs6 fw300">Save This Transaction as a Quotation?</h3>
    <div className="fx-cl spacem">
      <p>
     This transaction will be saved as a quotation, allowing you to review,
  edit, and complete the sale later without processing payment or updating
  inventory.
    </p> 
    <p>note that this process will not updating
  inventory or precessed any payments.
    </p> 
    </div>
  </div>
          <div className="cashPaymentDisc fx-cl" style={{
    padding: '0 3rem',
    width: '37rem',
  }}
  >
            <div className="cashPaymentRow">
              <div className="fx-ac spacem">
                <ShoppingCartIcon fontSize="large" /> <span>Products:</span>
              </div>
              <p>{cart?.length} items</p>
            </div>
            <div className="cashPaymentRow">
              <div className="fx-ac spacem">
                <EventRoundedIcon fontSize="large" /> <span>Grand Total:</span>
              </div>
              <p>
                <strong>₦ {total.toLocaleString()}</strong>
              </p>
            </div>
            <div className="cashPaymentRow">
              <div className="fx-ac spacem">
                <WorkspacePremiumRoundedIcon fontSize="large" />{" "}
                <span>Discount:</span>
              </div>
              <p> ₦ {discount?.amount || 0.00} </p>
            </div>
            <div className="cashPaymentRow ">
              <div className="fx-ac spacem">
                <AccountCircleRoundedIcon fontSize="large" /> <span>Customer:</span>
              </div>
              <p style={{ color: "#fff", fontWeight: "bold" }}>
                {customerName}
                   
              </p>
            </div>
          </div>
          </main>
          <div className="fx-ac fx-jb space3">
            <input type="text" className="saveQuotsDiscription" placeholder="Description.."/>
            <button className="animatedBtnShine" onClick={() =>saveQuotation()}>Save Quoatation</button>
          </div>
        </div>
     
  );
 }
export function Discount({ cart, setOpenModal }) {
  const dispatch = useDispatch();
  const [discountInPercent, setDiscountInPercent] = useState(false);
  const [discountAmount, setDiscountAmount] = useState("");

  const actualPrice = cart.reduce(
    (sum, item) => sum + item.pricing.sellingPrice * item.soldQuantity,
    0,
  );

  const discount = () => {
    if (discountInPercent) {
      return (actualPrice * discountAmount) / 100;
    } else {
      return Number(discountAmount);
    }
  };

  const estimate = actualPrice - discount();

  function handleDiscount() {
    dispatch(
      Action.dispatchDiscount({
        amount: discount(),
        type: discountInPercent ? "percentage" : "fixed",
        description: "",
      }),
    );
    setOpenModal(false);
  }

  return (
    <div
      className="discountCont fx-cl space2"
      onClick={(e) => e.stopPropagation()}
    >
      <span>Enter amount below</span>
      <div className="discountInputCont fx-jb">
        <h2 className="fx-cl space1">
          <button
            className={`${!discountInPercent && "active"}`}
            onClick={() => {
              setDiscountInPercent(false);
              setDiscountAmount("");
            }}
          >
            ₦
          </button>
          <button
            className={`${discountInPercent && "active"}`}
            onClick={() => {
              setDiscountInPercent(true);
              setDiscountAmount("");
            }}
          >
            %
          </button>
        </h2>
        <input
          type="number"
          name="discount"
          id="discountInput"
          placeholder={discountInPercent ? "%" : "₦"}
          value={discountAmount}
          min={discountInPercent ? 0 : 1}
          max={discountInPercent ? 100 : actualPrice}
          onChange={(e) => {
            const value = e.target.value;

            // Allow clearing the input
            if (value === "") {
              setDiscountAmount("");
              return;
            }

            const num = Number(value);

            if (discountInPercent) {
              if (num >= 0 && num <= 100) {
                setDiscountAmount(value);
              }
            } else {
              if (num >= 1 && num <= actualPrice) {
                setDiscountAmount(value);
              }
            }
          }}
        />
      </div>
      <div className="fx-cl">
        <div className="fx-cl spacem">
          <div className="discountBar fx-ac fx-jb space2">
            <div className="disBarMdl fx-ac fx-jc">
              <AccountCircleRoundedIcon />
            </div>
            <div className="disBarTop">&nbsp;</div>

            <div className="fx-ac spacem">
              <figure>
                <AccountCircleRoundedIcon />
              </figure>
              <span>Actual</span>
            </div>
            <span> ₦ {actualPrice.toLocaleString()}</span>
          </div>
          <div className="fx-cl space1">
            <div className="discountBar fx-ac fx-jb space2">
              <div className="disBarBtm">&nbsp;</div>
              <div className="fx-ac spacem">
                <figure>
                  <EventRoundedIcon />
                </figure>
                <span>Discount</span>
              </div>
              <span>
                {" "}
                ₦{" "}
                {discountInPercent
                  ? discount().toLocaleString()
                  : discountAmount.toLocaleString()}{" "}
              </span>
            </div>
          </div>
        </div>
        <div className=" discountEstimation fx-ac space2 fx-jb">
          <span>Estimated fee</span>
          <span>
            <strong> ₦ {estimate.toLocaleString()} </strong>
          </span>
        </div>
      </div>
      <div className="discountSubmit fx-ac">
        <button
          className="confirmDiscountBtn"
          onClick={() => {
            if (Number(discountAmount) > 0) {
              handleDiscount();
            }
          }}
          style={{
            cursor: Number(discountAmount) > 0 ? "pointer" : "not-allowed",
            backgroundColor: Number(discountAmount) > 0 ? "#3a84f8" : "#ededed",
            color: Number(discountAmount) > 0 ? "#fff" : "#444",
            opacity: Number(discountAmount) > 0 ? 1 : 0.6,
            fontFamily: "cursive",
          }}
        >
          Apply Discount
        </button>
      </div>
      <div className="discountFoot fx-ac fx-jc">
        <ForumRoundedIcon /> Highly secured and encryped by Green
      </div>
    </div>
  );
}
export function HoldedSales({
  onHoldData,
  attendOnHold,
  deleteOnHold,
  moveOnHoldToDraf,
  handleHoldedSale,
}) {
  return (
    <>
      <OnholdTransactions
        onHoldData={onHoldData}
        attendOnHold={attendOnHold}
        deleteOnHold={deleteOnHold}
        moveOnHoldToDraf={moveOnHoldToDraf}
        handleHoldedSale={handleHoldedSale}
      />
    </>
  );
}
export function Contacts({ clientData, setOpenModal }) {
  const { enqueueSnackbar } = useSnackbar();
  const [loading, setLoading] = useState(false);

  // ===========================================================

  const apiGetContact = async () => {
    setLoading(true);

    try {
      const { data } = await axios.get(
        `${process.env.REACT_APP_SERVER_SCRIPT_HOST}/client/${clientData?.clientId}/contacts/fetch_contact`,
        {
          timeout: 30000,
          headers: {
            "Content-Type": "application/json",
          },
        },
      );

      const { status, message, nContact } = data;
      contacts = nContact;

      console.log(status, message, nContact);
      switch (status) {
        case 201:
          console.log("success");
        case 408:
        case 409:
        case 400:
        case 401:
        case 403:
        case 404:
        case 422:
          enqueueSnackbar(message, {
            variant: "error",
            autoHideDuration: 3000,
          });
          // setOpenModal(false);
          break;

        default:
          enqueueSnackbar(
            message || "An unexpected server response was received.",
            {
              variant: "warning",
              autoHideDuration: 3000,
            },
          );
      }
    } catch (error) {
      if (!error.response) {
        enqueueSnackbar(
          "Unable to connect to the server. Check your internet connection.",
          {
            variant: "error",
          },
        );
      } else if (error.code === "ECONNABORTED") {
        enqueueSnackbar("Request timed out. Please try again.", {
          variant: "error",
        });
      } else if (error.response.status >= 500) {
        enqueueSnackbar("The server encountered an error.", {
          variant: "error",
        });
      } else {
        enqueueSnackbar(error.response.data?.message || error.message, {
          variant: "error",
        });
      }
      console.error("Get contacts ERR: ", error?.code || "REQUEST_FAILED");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    apiGetContact();
  }, []);

  return (
    <>
      {" "}
      {loading && <IsLoading />}
      <div
        className="contactWrapper fx-cl space2"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="contactCont fx-cl space4">
          <div className="fx-ac fx-jb space3">
            <div className="fx-cl space1">
              <h3 className="fs6 fw600">
                <span>Access All Contacts </span>{" "}
                <span style={{ color: "#3a84f8" }}> Added to Your Account</span>
              </h3>
              <span className="fs3">
                Your Complete List of Saved Client Contacts
              </span>
              <div className="fx-ac">
                <figure className="contactTopFig fx-ac space1">
                  <span className="fx-ac space1">
                    Total{" "}
                    <span className="tag">
                      {contacts?.length || 0} contacts
                    </span>
                  </span>
                  <button className="fs1 fw500 fx-ac fx-jb">
                    <AddOutlinedIcon fontSize="medium" /> <span>Add new</span>
                  </button>
                </figure>
              </div>
            </div>
            <button
              className="btnCloseContacts fx-ac fx-jc"
              onClick={() => setOpenModal(false)}
            >
              <CloseOutlinedIcon style={{ fontSize: "3.1rem" }} />
            </button>
          </div>
          <div className="contactsItem g g3">
            {contacts?.map((contact) => (
              <figure className="theContact" key={contact._id}>
                <div className="theContTop fx-cl space2">
                  <div className="fx-ac space2 fx-jb">
                    <span className="fs1">
                      {contact?.contact?.address?.city || "No City"}
                    </span>

                    <span className="fs1">
                      Total transaction: {contact?.activity?.totalTransactions}
                    </span>
                  </div>

                  <div className="contactDiscr spacem">
                    <span className="theContactImg fx-ac fx-jc fw600 fs6">
                      {contact?.profile?.photo ? (
                        <img
                          src={contact.profile.photo}
                          alt={contact.profile.fullName}
                        />
                      ) : (
                        <span>
                          {contact?.profile?.fullName?.charAt(0).toUpperCase()}
                        </span>
                      )}
                    </span>

                    <div className="fx-cl">
                      <span className="fs5 fw500">
                        {contact?.profile?.fullName?.length > 20
                          ? `${contact.profile.fullName.slice(0, 20)}...`
                          : contact?.profile?.fullName}
                      </span>

                      <div className="fx-ac">
                        <span>.</span>
                        <span className="fsmini">
                          {contact?.notes?.description?.length > 73
                            ? `${contact?.notes?.description.slice(0, 73)}...`
                            : contact?.notes?.description}
                        </span>
                      </div>
                    </div>
                  </div>

                  <div className="fx-ac space2">
                    <button className="fx-ac spacem">
                      <InfoOutlinedIcon />
                      <span>Details</span>
                    </button>

                    <button className="fx-ac spacem">
                      <AddShoppingCartOutlinedIcon />
                      <span>Transaction</span>
                    </button>
                  </div>
                </div>

                <div className="theContFoot">
                  <div className="fx-ac spacem fx-jc">
                    <CallIcon />
                    <span className="fs1 fw500">
                      {contact?.contact?.phone?.primary || "No Phone"}
                    </span>
                  </div>
                </div>
              </figure>
            ))}
          </div>
        </div>
      </div>
    </>
  );
}
